import React, { useState, useEffect } from "react";

import { Amplify, Auth } from "aws-amplify";
import AdminAuth from "./AdminAuth";
import MainApp from "./MainApp";
import configAmplify from "../../config-amplify";

Amplify.configure(configAmplify);

const AppContent = () => {
  const [user, setUser] = useState(null);

  const fetchCurrentUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser({ bypassCache: false });
      if (user) setUser(user);
    } catch (err) {
      console.log("No user found", err);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  return <div>{user ? <MainApp /> : <AdminAuth />}</div>;
};

export default AppContent;
